import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import client from "../../sanity/sanityClient";
import { urlFor } from "../../sanity/sanityClient";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const BlogSection = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    // Fetch blog posts from Sanity
    client
      .fetch(
        `*[_type == "post"] | order(publishedAt desc)[0...3] {
          _id,
          title,
          slug,
          publishedAt,
          mainImage,
          body
        }`
      )
      .then((data) => {
        setPosts(data);
      })
      .catch((err) => console.error("Error fetching posts:", err));
  }, []);

  return (
    <section className="wpo-blog-section section-padding">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col col-md-6 col-12">
            <div className="wpo-section-title">
              <div className="section-titl-shape-1">
                <svg width="687" height="473" viewBox="0 0 687 473" fill="none">
                  <g opacity="0.44" filter="url(#filter0_f_1_104)">
                    <circle cx="343.5" cy="129.5" r="129.5" />
                  </g>
                  <defs>
                    <filter
                      id="filter0_f_1_104"
                      x="0"
                      y="-214"
                      width="687"
                      height="687"
                      filterUnits="userSpaceOnUse"
                      colorInterpolationFilters="sRGB"
                    >
                      <feFlood floodOpacity="0" result="BackgroundImageFix" />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                      />
                      <feGaussianBlur
                        stdDeviation="107"
                        result="effect1_foregroundBlur_1_104"
                      />
                    </filter>
                  </defs>
                </svg>
              </div>
              <div className="section-titl-shape-2">
                <svg width="687" height="473" viewBox="0 0 687 473" fill="none">
                  <g opacity="0.44" filter="url(#filter0_f_1_1050)">
                    <circle cx="343.5" cy="129.5" r="129.5" />
                  </g>
                  <defs>
                    <filter
                      id="filter0_f_1_1050"
                      x="0"
                      y="-214"
                      width="687"
                      height="687"
                      filterUnits="userSpaceOnUse"
                      colorInterpolationFilters="sRGB"
                    >
                      <feFlood floodOpacity="0" result="BackgroundImageFix" />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                      />
                      <feGaussianBlur
                        stdDeviation="107"
                        result="effect1_foregroundBlur_1_105"
                      />
                    </filter>
                  </defs>
                </svg>
              </div>
              <span>Campaign Blog</span>
              <h2>Read More About Taisha and the Campaign.</h2>
            </div>
          </div>
        </div>
        <div className="blog-wrap">
          <div className="row">
            {posts.map((post) => (
              <div className="col-lg-4 col-md-6 col-12" key={post._id}>
                <div className="blog-item">
                  <div className="image">
                    {post.mainImage ? (
                      <img
                        src={urlFor(post.mainImage)
                          .width(300)
                          .height(200)
                          .url()}
                        alt={post.title}
                      />
                    ) : (
                      <img
                        src="/placeholder-image.png" // Fallback image if none provided
                        alt="Placeholder"
                      />
                    )}
                  </div>
                  <div className="dete">
                    <span>
                      {new Date(post.publishedAt).toLocaleDateString(
                        undefined,
                        {
                          day: "numeric",
                        }
                      )}
                    </span>
                    <strong>
                      {new Date(post.publishedAt).toLocaleDateString(
                        undefined,
                        {
                          month: "short",
                        }
                      )}
                    </strong>
                  </div>
                  <div className="blog-content">
                    <h2>{post.title}</h2>
                    <p>{post.body[0]?.children[0]?.text.slice(0, 100)}...</p>
                    <Link
                      onClick={ClickHandler}
                      to={`/blog-single/${post.slug.current}`}
                      className="theme-btn-s2"
                    >
                      READ MORE
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
